var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 359,
    viewBox: "0 0 382 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2554_6768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.59 336.518H115.7L128.689 247.467H237.591L250.59 336.518Z",
    fill: "#19A8D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.852 263.162H15.4273C6.9094 263.162 0 256.264 0 247.76V36.7938C0 28.2796 6.9094 21.3814 15.4273 21.3814H350.852C359.37 21.3814 366.279 28.2796 366.279 36.7837V247.75C366.279 256.264 359.37 263.162 350.852 263.162Z",
    fill: "#1EB6E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.96 237.802H24.3091C15.7912 237.802 8.88184 230.903 8.88184 222.399V44.0657C8.88184 35.5617 15.7912 28.6634 24.3091 28.6634H341.96C350.478 28.6634 357.387 35.5617 357.387 44.0657V222.389C357.397 230.903 350.488 237.802 341.96 237.802Z",
    fill: "#DBF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.179 343.002H87.1113V333.74C87.1113 326.579 92.9282 320.772 100.101 320.772H266.189C273.362 320.772 279.179 326.579 279.179 333.74V343.002Z",
    fill: "#1EB6E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2529 237.802H339.593",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5586 338.366V333.498C95.5586 330.559 97.946 328.175 100.89 328.175H244.935",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.639 270.283L234.737 309.187",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.918 258.728C184.047 258.728 187.394 255.387 187.394 251.265C187.394 247.142 184.047 243.801 179.918 243.801C175.789 243.801 172.442 247.142 172.442 251.265C172.442 255.387 175.789 258.728 179.918 258.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.239 42.8639H325.905C333.462 42.8639 339.592 48.9844 339.592 56.529V138.813",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.508 68.9215C318.794 63.4171 321.06 59.1651 323.306 56.1553C325.542 53.1455 328.465 50.7418 332.056 48.9541C334.161 47.8532 336.346 47.0755 338.632 46.5907C340.908 46.116 343.083 45.51 345.137 44.7828C347.19 44.0556 349.082 43.0558 350.812 41.8034C352.542 40.551 353.968 38.5714 355.091 35.8646C356.993 31.2995 357.064 27.5727 355.294 24.7144C353.523 21.846 350.913 19.6948 347.464 18.2606C342.507 16.2002 338.531 16.1699 335.516 18.1394C332.502 20.1189 329.79 23.3408 327.383 27.805L309.305 20.3007C311.207 15.7356 313.685 11.8876 316.73 8.77679C319.775 5.66603 323.225 3.37336 327.069 1.90888C330.913 0.444395 335.061 -0.191897 339.522 0.0202002C343.984 0.232298 348.546 1.30288 353.22 3.24206C363.306 7.43351 370.417 12.7864 374.555 19.311C378.682 25.8355 378.824 33.7235 374.98 42.9548C373.735 45.9443 372.35 48.4289 370.802 50.4085C369.264 52.3981 367.504 54.0444 365.531 55.3574C363.559 56.6704 361.353 57.7511 358.925 58.5995C356.487 59.4479 353.796 60.2457 350.863 60.9931C348.141 61.7304 345.875 62.5081 344.054 63.3363C342.233 64.1645 340.676 65.1947 339.401 66.4067C338.126 67.6288 337.054 69.0124 336.184 70.5678C335.314 72.1232 334.454 73.9311 333.604 75.9814L316.508 68.9215ZM304.702 95.6963L312.33 77.365L331.247 85.2126L323.62 103.544L304.702 95.6963Z",
    fill: "#212348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.27 96.4336V81.4656C206.27 76.557 202.285 72.5777 197.368 72.5777H110.338C105.421 72.5777 101.436 76.557 101.436 81.4656V96.4336V196.15C101.436 201.058 105.421 205.038 110.338 205.038H249.507C254.424 205.038 258.41 201.058 258.41 196.15V105.321C258.41 100.413 254.424 96.4336 249.507 96.4336H206.27Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.449 117.34L179.918 134.843L162.386 117.34L151.805 127.905L169.336 145.408L151.805 162.911L162.386 173.475L179.918 155.972L197.449 173.475L208.031 162.911L190.499 145.408L208.031 127.905L197.449 117.34Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.64 175.445L253.018 170.435L266.938 172.981L273.898 165.567L290.367 169.971L299.532 157.467L315.89 167.476L310.326 132.167L288.738 117.078L239.118 124.875C237.257 125.168 235.992 126.905 236.285 128.763L243.64 175.445Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.786 134.763L310.336 132.167L288.748 117.078L291.247 132.924C291.429 134.126 292.572 134.954 293.786 134.763Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.738 117.078L291.237 132.924C291.429 134.136 292.572 134.965 293.786 134.773L310.336 132.177",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.337 221.803C250.631 223.662 252.371 224.924 254.232 224.631L319.239 214.42C321.1 214.127 322.365 212.39 322.072 210.532L315.901 171.415L299.543 161.406L290.377 173.91L273.908 169.506L266.948 176.919L253.028 174.374L243.65 179.384L250.337 221.803Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.66 175.445L253.038 170.435L266.958 172.981L273.918 165.567L290.387 169.971L299.553 157.467L315.911 167.476L310.347 132.167L288.759 117.078L239.139 124.875C237.277 125.168 236.013 126.905 236.306 128.763L243.66 175.445Z",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.347 221.803C250.64 223.662 252.38 224.924 254.242 224.631L319.249 214.42C321.11 214.127 322.375 212.39 322.081 210.532L315.91 171.415L299.552 161.406L290.387 173.91L273.918 169.506L266.958 176.919L253.038 174.374L243.66 179.384L250.347 221.803Z",
    stroke: "#262626",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.657 355.435C216.751 350.617 216.68 342.749 221.506 337.851L278.855 279.585L296.619 297.017L239.27 355.283C234.454 360.182 226.564 360.252 221.657 355.435Z",
    fill: "#212348"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M323.987 301.896C351.805 301.833 374.305 279.268 374.242 251.495C374.178 223.722 351.576 201.258 323.759 201.321C295.941 201.384 273.441 223.95 273.504 251.723C273.567 279.496 296.169 301.959 323.987 301.896Z",
    fill: "#DCF0FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M276.73 269.333C278.43 273.848 280.797 278.161 283.832 282.12L374.221 250.911C374.15 246.033 373.371 241.165 371.894 236.468L276.73 269.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M273.614 254.931C273.806 257.779 274.231 260.617 274.909 263.415L369.668 230.691C368.485 228.116 367.078 225.611 365.44 223.217L273.614 254.931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.611 210.219C341.718 187.757 304.905 188.07 282.406 210.936C259.907 233.792 260.221 270.545 283.124 293.007C306.017 315.47 342.83 315.156 365.329 292.29C387.828 269.424 387.514 232.681 364.611 210.219ZM290.317 285.695C271.46 267.192 271.197 236.933 289.73 218.107C308.263 199.281 338.572 199.018 357.428 217.521C376.285 236.024 376.548 266.283 358.015 285.109C339.482 303.935 309.174 304.198 290.317 285.695Z",
    fill: "#212348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.891 302.38L237.54 348.456",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.04 197.745C313.756 196.311 298.936 201.23 288.364 210.936C277.793 220.642 271.632 234.963 271.865 249.295",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2554_6768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 382,
    height: 359,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProduct);
export default __webpack_public_path__ + "static/media/NoProduct.d785c3b36aec7ee107fc911e48b34656.svg";
export { ForwardRef as ReactComponent };